import React from "react";
import { X } from "lucide-react";
import { useAskTessa } from "@v2/components/ai/AskTessaProvider";
import { Button } from "@v2/components/ui/button";
import { cn } from "@v2/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider
} from "@v2/components/ui/tooltip";
import { useBreakpoint } from "@gettactic/helpers/src/hooks/useBreakpoint";
import { AiIcon } from "@v2/icons";

export interface ChatBotBubbleProps {
  className?: string;
}

export const ChatBotBubble: React.FC<ChatBotBubbleProps> = ({ className }) => {
  const askTessa = useAskTessa();
  const { isBreakpoint } = useBreakpoint();
  const isMd = isBreakpoint("md");
  if (!askTessa) return null;

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger>
          <Button
            variant="default"
            onClick={() => askTessa.tessaDisclosure.toggle()}
            className={cn(
              "flex h-14 w-14 items-center justify-center rounded-full shadow-md transition-all duration-300 hover:shadow-black/30 hover:shadow-lg",
              className
            )}
          >
            {askTessa.tessaDisclosure.isOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <AiIcon className="h-6 w-6" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side={isMd ? "right" : "top"} align="center">
          <span className={"flex items-center gap-1"}>
            <AiIcon className={"size-4"} /> Ask tessa -{" "}
            <span className={"text-neutral-600 text-sm"}>⌘⇧A</span>
          </span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
